import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { loadingStart, loadingSuccess } from "./loading";
import { getGData } from "./ggame";
import { GetUserBlance } from "./userbal";
const initialState = {
  data: null,
  loading: false,
  error: null,
};

const authBalanceSlice = createSlice({
  name: "getbalance",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
  },
});

// Actions
export const {  ApiSuccess, requestFailure } =
  authBalanceSlice.actions;

export const GetBlanceSlice = (data) => async (dispatch) => {
  try {
    dispatch(loadingStart());
    const response = await axios.post(`/private/user/getbalance`, data);
    if (response.status === 200) {
      dispatch(ApiSuccess(response.data));
      dispatch(GetUserBlance(data));
      dispatch(getGData());
      toast.success("Balance updated successfully");
      dispatch(loadingSuccess("Created successfully!"));
    } else if (response.status === 201) {
      dispatch(ApiSuccess(response.data));
      toast.info("Balance update query in progress");
      dispatch(loadingSuccess("Created successfully!"));
    } else if (response.status === 202) {
      dispatch(ApiSuccess(response.data));
      toast.info("Balance update query in progress");
      dispatch(loadingSuccess("Created successfully!"));
    }
  } catch (err) {
    // Handle errors
    // toast.error(err?.response?.data?.message || err.message || " failed!");
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export default authBalanceSlice.reducer;
